import { colors, paddings, fonts } from '~/layout';
import * as lib from '~/dependencies';

export const Container = lib.styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 0px ${paddings.alternative}px ${paddings.alternative}px;
`;

export const HelpItemsList = lib.styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;

  .row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    cursor: pointer;
    height: 48px;
    background-color: ${colors.white02};
    border: 1px dotted ${colors.lightGray06};
    border-radius: 10px;
    padding-left: ${paddings.alternative}px;
    padding-right: ${paddings.alternative}px;
    margin-bottom: 5px;

    .active {
      color: ${colors.lightBlue};
    }
    div {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      flex: 1;

      span {
        color: ${colors.black};

        &:first-child {
          text-transform: uppercase;
          font-size: ${fonts.default}px;
        }
        &:last-child {
          font-size: ${fonts.label}px;
          opacity: 0.5;
        }
      }
    }

    .icon {
      max-width: 25px;
    }

  }
`;

export const ReportProblemScene = lib.styled.div`
  .report-by-calling {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: 15px;
    margin-right: 15px;

    .title {
      display: flex;
      margin-bottom: 10px;
      color: ${colors.darkGray02}
    }

    .description {
      text-align: center;
      margin: 40px 40px;
      color: ${colors.darkGray02}
    }

    .smaller-margin {
      margin-bottom: 20px;
    }

    .call-for-help-buttom {
      display: flex;
      align-self: center;
      width: 200px;
      height: 50px;
      background: linear-gradient(50.28deg, #61BB46 2.79%, #79c961 73.37%);
      border-radius: 30px;
      outline: none;
      border: 0!important;
      font-weight: bold;
      font-size: ${fonts.btnSubmitLoginSize}px;
      text-align: center;
      align-items: center;
      justify-content: center;
      margin-left: 10px;
      cursor: pointer;

      .loading {
        color: ${colors.white};
        width: 15px!important;
        height: 15px!important;
      }

      span {
        color: ${colors.white};
        text-align: center;
        align-items: center;
        justify-content: center;
        font-size: ${fonts.btnSubmitLoginSize}px;
        padding-top: 3px;
      }
    }
  }
`;
